import { reactive } from "vue";

export const loadingState = reactive({
    isLoadingComplete: false,
});

export function setLoadingComplete() {
    loadingState.isLoadingComplete = true;
}
